<app-header (onSearchRegion)="onGetRegion($event)"></app-header>
<app-featured (onSearchRegion)="onGetRegion($event)" [regions]="regions"></app-featured>
<app-middle-call-to-action></app-middle-call-to-action>
<!-- <app-main></app-main> -->
<app-faq></app-faq>
<app-footer [regions]="regions"></app-footer>
<app-floating-contact [regions]="regions"></app-floating-contact>